import { Controller } from 'stimulus';

// Click the summary line on a template row → toggle the popover next to it.
// Click anywhere outside (or another summary) closes it. One popover open
// at a time across the page.
export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this.boundOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener('click', this.boundOutsideClick, true);
  }

  disconnect() {
    document.removeEventListener('click', this.boundOutsideClick, true);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const opening = this.menuTarget.classList.contains('is-hidden');
    this.closeAll();
    if (opening) this.menuTarget.classList.remove('is-hidden');
  }

  handleOutsideClick(event) {
    if (this.menuTarget.classList.contains('is-hidden')) return;
    if (this.element.contains(event.target)) return;
    this.menuTarget.classList.add('is-hidden');
  }

  closeAll() {
    // Closes popovers on every surface this controller drives: the templates
    // index (`.ti-cpop`), the jobs-list field summary (`.jlv-cpop`), and the
    // jobs-list task ring (`.jlv-taskpop`).
    document.querySelectorAll('.ti-cpop, .jlv-cpop, .jlv-taskpop').forEach((p) => p.classList.add('is-hidden'));
    document.querySelectorAll('.ti-rowmenu').forEach((m) => m.classList.add('is-hidden'));
  }
}
